import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MealPeriodComponent } from './meal-period.component';
import { ShowMealPeriodPipe } from './show-meal-period.pipe';
import { FormatTimePipeModule } from '@finder/shared/utils/pipes/format-time/format-time.module';

@NgModule({
    imports: [
        CommonModule,
        FormatTimePipeModule,
    ],
    declarations: [
        MealPeriodComponent,
        ShowMealPeriodPipe,
    ],
    providers: [],
    exports: [
        MealPeriodComponent,
    ]
})
export class MealPeriodModule {}
